import { useState } from "react"
import { Form } from "antd"
import { Input } from "components/ui/inputs/Input"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { RemoveIcon } from "components/ui/icons/quotations/RemoveIcon"
import style from "./DimensionInputs.module.scss"

const { dimensionsBlock, inputBlock, formItem, input, addButton, allDimensions, dimensionsItem } = style

type Props = {
	label: string
	values: string[]
	onAdd: (value: string) => void
	onRemove: (value: string) => void
	hasError?: boolean
}

export const DimensionInputs = ({ label, values, onAdd, onRemove, hasError }: Props) => {
	const [inputValue, setInputValue] = useState("")

	const handleAdd = () => {
		const trimmed = inputValue.trim()
		if (!trimmed || values.includes(trimmed)) return
		onAdd(trimmed)
		setInputValue("")
	}

	return (
		<div className={dimensionsBlock}>
			<span>{label}</span>
			<div className={inputBlock}>
				<Form.Item className={formItem}>
					<Input
						placeholder="e.g. 24 or 24-20"
						className={input}
						value={inputValue}
						onChange={(e) => setInputValue(e.target.value)}
						onPressEnter={handleAdd}
						status={hasError ? "error" : undefined}
					/>
				</Form.Item>
				<ButtonPrimary className={addButton} onClick={handleAdd}>
					Add
				</ButtonPrimary>
			</div>
			{values.length > 0 ? (
				<div className={allDimensions}>
					{values.map((value) => (
						<button type="button" className={dimensionsItem} key={value} onClick={() => onRemove(value)}>
							<span>{value}</span>
							<RemoveIcon />
						</button>
					))}
				</div>
			) : null}
		</div>
	)
}
